import { Injectable } from '@angular/core';

import { QuoteModel } from '@bytel/bytel-sales';
import { QuoteContextRenewalModel, UserLevelsData, UserService } from '@bytel/checkout';

import { MainCartService } from '@services/main-cart.service';
import { MessageService } from '@services/message.service';

import { Observable, of } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';

import { BasicObject } from '../interfaces/checkout.interface';
import { CustomerErrorModalComponent } from '../shared/customer-error-modal/customer-error-modal.component';
import { ErrorModalComponent } from '../shared/error-modal/error-modal.component';

@Injectable({
    providedIn: 'root',
})
export class CustomerResolver {
    constructor(
        private userService: UserService,
        private messageService: MessageService,
        private cartService: MainCartService,
    ) {}

    public resolve(): Observable<UserLevelsData> {
        const quote: QuoteModel = this.cartService.getQuote();

        if (quote.isRenewal()) {
            this.userService.user.renewContractId = (
                this.cartService.getQuote().context as QuoteContextRenewalModel
            ).contractId;
        }

        return this.userService.signupData().pipe(
            mergeMap((data: UserLevelsData) => {
                const storedUserData: BasicObject = this.userService.getStoredUserData();
                if (this.userService.user?.id && !storedUserData?.data) {
                    this.userService.save({
                        data: this.userService.mapUserDataToStorageData(),
                        address: this.userService.user?.address,
                    });
                }

                const cartUserId: string = this.cartService.cartModel.userId;
                if (cartUserId && cartUserId !== this.userService.user.id) {
                    this.cartService.deleteCartIds();
                    return null;
                }

                return of(data);
            }),
            catchError((error) => {
                console.warn(error);
                if (error.status === UserService.ERROR_TYPES.UNAUTHORIZED) {
                    this.messageService.openModal(CustomerErrorModalComponent);
                } else {
                    this.messageService.openModal(ErrorModalComponent);
                }
                return of(null);
            }),
        );
    }
}
